import { API_ROUTES } from "@/constant";
import PaymentAPI from "@/services/Payment/PaymentConfig";

export const generateRedemptionEInvoice = async (
  pledge_id: number,
  is_auto_generated: boolean = false,
): Promise<any> => {
  const response = await PaymentAPI.post(API_ROUTES.PLEDGE_REDEMPTION_EINVOICE_SUBMIT, {
    pledge_id,
    is_auto_generated,
  });

  return response.data;
};

export const generateRenewalEInvoice = async (
  pledge_id: number,
  is_auto_generated: boolean = false,
): Promise<any> => {
  const response = await PaymentAPI.post(API_ROUTES.PLEDGE_RENEWAL_EINVOICE_SUBMIT, {
    pledge_id,
    is_auto_generated,
  });

  return response.data;
};

export const generatePledgeCreationEInvoice = async (
  pledge_id: number,
  is_auto_generated: boolean = false,
): Promise<any> => {
  const response = await PaymentAPI.post(API_ROUTES.PLEDGE_CREATION_EINVOICE_SUBMIT, {
    pledge_id,
    is_auto_generated,
  });

  return response.data;
};
